import { UuidableName } from 'utils/api/types';

export enum MembershipMode {
  Manual = 'manual',
  Dynamic = 'dynamic',
}

export interface MemberGroupListItem extends UuidableName {
  description: string;
  membershipMode: MembershipMode;
  active: boolean;
  memberCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface MemberGroupSearchResult extends UuidableName {
  memberCount: number;
}

export enum RuleCombinator {
  All = 'all',
  Any = 'any',
}

export type RuleOperator =
  | 'is'
  | 'isNot'
  | 'isAnyOf'
  | 'isNoneOf'
  | 'contains'
  | 'doesNotContain'
  | 'startsWith'
  | 'isEmpty'
  | 'isNotEmpty';

export interface RuleConditionRequest {
  attribute: string;
  operator: RuleOperator;
  values?: string[];
}

export interface RuleRequest {
  combinator: RuleCombinator;
  conditions: RuleConditionRequest[];
}

export interface RuleConditionResponse {
  attribute: string;
  operator: RuleOperator;
  values: Array<string | UuidableName>;
}

export interface RuleVersion {
  version: number;
  combinator: RuleCombinator;
  conditions: RuleConditionResponse[];
}

export interface PreviewCounts {
  all: number;
  joining: number;
  leaving: number;
}

export type PreviewStatus = 'all' | 'joining' | 'leaving';

export interface MemberGroupDetailResponse extends UuidableName {
  description: string;
  membershipMode: MembershipMode;
  active: boolean;
  memberCount: number;
  createdAt: string;
  updatedAt: string;
  rule: RuleVersion | null;
}

export interface UserMemberGroupRow extends UuidableName {
  membershipMode: MembershipMode;
}

export interface MemberRow extends UuidableName {
  jobTitle: string | null;
  department: UuidableName | null;
  site: UuidableName | null;
}

export type MemberGroupHistoryEventType =
  | 'group_created'
  | 'member_added'
  | 'member_removed'
  | 'renamed'
  | 'description_changed'
  | 'rule_changed'
  | 'mode_switched'
  | 'group_activated'
  | 'group_deactivated';

export type MemberGroupHistoryCause = 'manual' | 'matched_rule' | 'rule_updated' | 'deactivation';

export interface MemberGroupHistoryRow {
  uuid: string;
  eventType: MemberGroupHistoryEventType;
  batch: string | null;
  batchSize: number | null;
  members: (UuidableName | null)[] | null;
  cause: MemberGroupHistoryCause | null;
  toMode: MembershipMode | null;
  detail: string;
  rule: RuleVersion | null;
  user: UuidableName | null;
  actor: UuidableName | null;
  createdAt: string;
}

export interface CreateMemberGroupRequest {
  name: string;
  description?: string;
  membershipMode: MembershipMode;
  memberUuids?: string[];
  rule?: RuleRequest;
}

export interface UpdateMemberGroupRequest {
  name?: string;
  description?: string;
  active?: boolean;
  membershipMode?: MembershipMode;
  rule?: RuleRequest;
}

export interface PreviewRequest {
  rule: RuleRequest;
  group?: string;
}

export interface PreviewMembersParams {
  status: PreviewStatus;
  limit: number;
  offset: number;
  ordering?: string;
  query?: string;
}

export interface MemberGroupUsageResponse {
  assignmentRules: number;
  documents: number;
  scheduledAudits: number;
  adHocAudits: number;
}
